import React, { FC } from 'react';
import PartnerRolesListPage from './partnerrole-list';
import { Routes, Route } from 'react-router-dom';
import RoleInformationPage from 'src/common/components/business/role-information-page';
import { useTranslation } from 'react-i18next';
import { Selector } from 'src/common/types';

const PartnerRolesIndex: FC = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route path={`/*`} element={<PartnerRolesListPage />} />
      <Route
        path={`/new`}
        element={
          <RoleInformationPage
            header={t('NewRole')}
            maxSelector={Selector.Partners}
            mode="new"
            previousRoute="/partnerroles"
            routes={[
              { path: '', breadcrumbName: t('Home') },
              { path: 'partnerroles', breadcrumbName: t('PartnerRoles') },
              { path: 'new', breadcrumbName: t('NewPartnerRole') },
            ]}
          />
        }
      />
      <Route
        path={`/update/:id`}
        element={
          <RoleInformationPage
            header={t('EditPartnerRole')}
            maxSelector={Selector.Partners}
            mode="edit"
            previousRoute="/partnerroles"
            routes={[
              { path: '', breadcrumbName: t('Home') },
              { path: 'partnerroles', breadcrumbName: t('PartnerRoles') },
              { path: 'new', breadcrumbName: t('EditPartnerRole') },
            ]}
          />
        }
      />
    </Routes>
  );
};

export default PartnerRolesIndex;
